// Import the old design component
import KB from '../design/knowledge-hub/kh';

// Revert to old version
export default KB;

